import { Dispatch, SetStateAction } from 'react';

import { FULL_PERCENT, PROGRESS_INTERVAL } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { getHistoryProgressId } from '@api/hitoryCheck';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IBranchProgress } from '@interfaces/cmModule/cmModule';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { HISTORY_CHECK_GET_PROGRESS } from '@constants/queryKeys';

interface IUseQueryHistoryProgressIdParams {
	progressId?: string;
	isProgressRun: boolean;
	setIsProgressRun: Dispatch<SetStateAction<boolean>>;
}

interface IUseQueryHistoryProgressIdReturnValue {
	progressData?: IBranchProgress;
}

export const useQueryHistoryProgressId = (
	params: IUseQueryHistoryProgressIdParams,
): IUseQueryHistoryProgressIdReturnValue => {
	const {
		progressId,
		setIsProgressRun,
		isProgressRun,
	} = params;

	const {
		data: progressData,
	} = useQuery<IBranchProgress | undefined>({
		queryKey: [
			HISTORY_CHECK_GET_PROGRESS,
			progressId,
		],
		queryFn: () => {
			if (progressId) return getHistoryProgressId(progressId);

			setIsProgressRun(false);
		},
		onSuccess: (data) => {
			if (data?.percentsProgress == FULL_PERCENT && progressId) {
				setIsProgressRun(false);
			}
		},
		onError: (err: IResponseError) => {
			setIsProgressRun(false);
			handleErrorFromMessage(err);
		},
		enabled: [!!progressId, isProgressRun],
		refetchInterval: isProgressRun ? PROGRESS_INTERVAL : false,
	});

	return { progressData };
};
